import { SearchFlightInput, TransportOutput } from '@allocab/allocab-commons-shared-types';
import { useMutation } from '@tanstack/react-query';
import type { UseMutationOptions } from '@tanstack/react-query';

import { passengerApi } from '../services/network/Api';
import { APIError } from '../services/network/types';

const fetchFlight = (input: SearchFlightInput) =>
  passengerApi.get<SearchFlightInput, TransportOutput>('/transport/v1/flight', input);

const useFetchFlight = (options: UseMutationOptions<TransportOutput, APIError, SearchFlightInput> = {}) => {
  const fetchFlightMutation = useMutation<TransportOutput, APIError, SearchFlightInput>({
    mutationFn: fetchFlight,
    ...options,
  });

  return fetchFlightMutation;
};

export default useFetchFlight;
